import { BrowserModule, Title } from '@angular/platform-browser';
import { APP_INITIALIZER, LOCALE_ID, NgModule, ErrorHandler } from '@angular/core';
import { NgcCookieConsentModule } from 'ngx-cookieconsent';
import { AppRoutingModule } from './app-routing.module';
import { ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import Bugsnag from '@bugsnag/js';
import { AppComponent } from './app.component';
import { CoreModule } from './core/core.module';
import { SharedModule } from './shared/shared.module';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { LocaleService } from './LocaleService';
import { ForgotPasswordModule } from './modules/forgot-password/forgot-password.module';
import { ForgotPasswordComponent } from './modules/forgot-password/components/forgot-password/forgot-password.component';
import { LoginModule } from './modules/login/login.module';
import { registerLocaleData } from '@angular/common';
import { cookieConfig } from './cookie-consent.config';
import { bugsnagConfig, errorHandlerFactory } from './bugsnag.config';


// configure Bugsnag ASAP
Bugsnag.start(bugsnagConfig);

export function localeIdFactory(localeService: LocaleService) {
    return localeService.getLocale();
  }

  export function localeInitializer(localeId: string) {
    return (): Promise<any> => {
      return new Promise((resolve, reject) => {
        // Load all supported locales upfront
        const localePromises = [
          import(`@angular/common/locales/en`).then(module => registerLocaleData(module.default)),
          import(`@angular/common/locales/fr`).then(module => registerLocaleData(module.default)),
          import(`@angular/common/locales/es`).then(module => registerLocaleData(module.default)),
          import(`@angular/common/locales/fr-CA`).then(module => registerLocaleData(module.default)),
          import(`@angular/common/locales/en-CA`).then(module => registerLocaleData(module.default)),
          import(`@angular/common/locales/es-MX`).then(module => registerLocaleData(module.default)),
          import(`@angular/common/locales/en-AU`).then(module => registerLocaleData(module.default)),
          import(`@angular/common/locales/en-NZ`).then(module => registerLocaleData(module.default))
        ];
        
        Promise.all(localePromises)
          .then(() => resolve(true))
          .catch(error => {
            console.error('Failed to load locale data', error);
            reject(error);
          });
      });
    };
  }
@NgModule({
    declarations: [
        AppComponent,
        ForgotPasswordComponent,
    ],
    imports: [
        BrowserModule,
        BrowserAnimationsModule,
        ReactiveFormsModule,
        AppRoutingModule,
        HttpClientModule,
        CoreModule,
        SharedModule,
        //TranslateModule.forRoot()
        ForgotPasswordModule,
        LoginModule,
        NgcCookieConsentModule.forRoot(cookieConfig),
    ],
    providers: [
        { provide: ErrorHandler, useFactory: errorHandlerFactory },
        LocaleService,
    { provide: LOCALE_ID, useFactory: localeIdFactory, deps: [LocaleService] },
    {
      provide: APP_INITIALIZER,
      multi: true,
      useFactory: localeInitializer,
      deps: [LOCALE_ID]
    },
        // {
        //     provide: LOCALE_ID,
        //     deps: [LocaleService],      //some service handling global settings
        //     useFactory: (LocaleService: { locale: string; }) => LocaleService.locale
         // },
        //{ provide: LOCALE_ID, useValue: 'fr-CA' },
        //SnackbarProvider,
        Title
    ],
    bootstrap: [AppComponent],
    //exports: [ResetPasswordComponent,ForgotPasswordComponent]
})
export class AppModule { }
//https://medium.com/dailyjs/dynamic-locales-in-angular-dd9a527ebe1f
//https://github.com/profanis/codeShotsWithProfanis/blob/44/environmental_variables_app_initializer/src/app/app.module.ts